// @generated by protoc-gen-connect-web v0.6.0 with parameter "target=ts,ts_nocheck=false"
// @generated from file api/billing_new/svc_billing_new.proto (package com.diagnocat.billing_new, syntax proto3)
/* eslint-disable */

import { AccountInfoStreamReq, AccountInfoStreamResp, CreateAccountPaymentMethodReq, CreateAccountPaymentMethodResp, CreateOrderReq, CreateOrderResp, DeleteAccountPaymentMethodReq, DeleteAccountPaymentMethodResp, DeleteOrderReq, DeleteOrderResp, GetAllAvailableProductsReq, GetAllAvailableProductsResp, GetAvailableProductsReq, GetAvailableProductsResp, ListDiagnocoinLedgerReq, ListDiagnocoinLedgerResp, PayOrderReq, PayOrderResp, ProcessOrderReq, ProcessOrderResp, SetAccountBillingInformationReq, SetAccountBillingInformationResp, SetAccountBillingZonesReq, SetAccountBillingZonesResp, SetAccountSettingsReq, SetAccountSettingsResp, SetAccountWithoutStripeInvoicesReq, SetAccountWithoutStripeInvoicesResp, SetTransactionNumberToOrderReq, SetTransactionNumberToOrderResp, Test_ExpireSubscriptionAfterReq, Test_ExpireSubscriptionAfterResp } from "./svc_billing_new_pb.js";
import { MethodKind } from "@bufbuild/protobuf";

/**
 * @generated from service com.diagnocat.billing_new.Billing
 */
export const Billing = {
  typeName: "com.diagnocat.billing_new.Billing",
  methods: {
    /**
     *  Get stream client with account info
     *
     * @generated from rpc com.diagnocat.billing_new.Billing.AccountInfoStream
     */
    accountInfoStream: {
      name: "AccountInfoStream",
      I: AccountInfoStreamReq,
      O: AccountInfoStreamResp,
      kind: MethodKind.ServerStreaming,
    },
    /**
     *  Get available product objects by available product id or geo zone or account id
     *
     * @generated from rpc com.diagnocat.billing_new.Billing.GetAvailableProducts
     */
    getAvailableProducts: {
      name: "GetAvailableProducts",
      I: GetAvailableProductsReq,
      O: GetAvailableProductsResp,
      kind: MethodKind.Unary,
    },
    /**
     *  Get all available products (salesman only)
     *
     * @generated from rpc com.diagnocat.billing_new.Billing.GetAllAvailableProducts
     */
    getAllAvailableProducts: {
      name: "GetAllAvailableProducts",
      I: GetAllAvailableProductsReq,
      O: GetAllAvailableProductsResp,
      kind: MethodKind.Unary,
    },
    /**
     *  Create order
     *
     * @generated from rpc com.diagnocat.billing_new.Billing.CreateOrder
     */
    createOrder: {
      name: "CreateOrder",
      I: CreateOrderReq,
      O: CreateOrderResp,
      kind: MethodKind.Unary,
    },
    /**
     *  Process order by id (salesman only)
     *
     * @generated from rpc com.diagnocat.billing_new.Billing.ProcessOrder
     */
    processOrder: {
      name: "ProcessOrder",
      I: ProcessOrderReq,
      O: ProcessOrderResp,
      kind: MethodKind.Unary,
    },
    /**
     *  Delete unprocessed order by id
     *
     * @generated from rpc com.diagnocat.billing_new.Billing.DeleteOrder
     */
    deleteOrder: {
      name: "DeleteOrder",
      I: DeleteOrderReq,
      O: DeleteOrderResp,
      kind: MethodKind.Unary,
    },
    /**
     *  Pay order (owner only)
     *
     * @generated from rpc com.diagnocat.billing_new.Billing.PayOrder
     */
    payOrder: {
      name: "PayOrder",
      I: PayOrderReq,
      O: PayOrderResp,
      kind: MethodKind.Unary,
    },
    /**
     *  Get stripe's page with payment method creation
     *
     * @generated from rpc com.diagnocat.billing_new.Billing.CreateAccountPaymentMethod
     */
    createAccountPaymentMethod: {
      name: "CreateAccountPaymentMethod",
      I: CreateAccountPaymentMethodReq,
      O: CreateAccountPaymentMethodResp,
      kind: MethodKind.Unary,
    },
    /**
     *  Delete account payment method by stripe's id
     *
     * @generated from rpc com.diagnocat.billing_new.Billing.DeleteAccountPaymentMethod
     */
    deleteAccountPaymentMethod: {
      name: "DeleteAccountPaymentMethod",
      I: DeleteAccountPaymentMethodReq,
      O: DeleteAccountPaymentMethodResp,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc com.diagnocat.billing_new.Billing.SetAccountBillingInformation
     */
    setAccountBillingInformation: {
      name: "SetAccountBillingInformation",
      I: SetAccountBillingInformationReq,
      O: SetAccountBillingInformationResp,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc com.diagnocat.billing_new.Billing.SetTransactionNumberToOrder
     */
    setTransactionNumberToOrder: {
      name: "SetTransactionNumberToOrder",
      I: SetTransactionNumberToOrderReq,
      O: SetTransactionNumberToOrderResp,
      kind: MethodKind.Unary,
    },
    /**
     * (salesman only)
     *
     * @generated from rpc com.diagnocat.billing_new.Billing.SetAccountBillingZones
     */
    setAccountBillingZones: {
      name: "SetAccountBillingZones",
      I: SetAccountBillingZonesReq,
      O: SetAccountBillingZonesResp,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc com.diagnocat.billing_new.Billing.SetAccountWithoutStripeInvoices
     */
    setAccountWithoutStripeInvoices: {
      name: "SetAccountWithoutStripeInvoices",
      I: SetAccountWithoutStripeInvoicesReq,
      O: SetAccountWithoutStripeInvoicesResp,
      kind: MethodKind.Unary,
    },
    /**
     *  Replace the account's behavioural settings. Requires
     *  `Billing_CanEditAccountSettings`.
     *
     *  The whole `Settings` message is written, so read-modify-write it rather
     *  than sending a partially populated one.
     *
     * @generated from rpc com.diagnocat.billing_new.Billing.SetAccountSettings
     */
    setAccountSettings: {
      name: "SetAccountSettings",
      I: SetAccountSettingsReq,
      O: SetAccountSettingsResp,
      kind: MethodKind.Unary,
    },
    /**
     *  Diagnocoin audit trail: every coin movement on an account, newest first.
     *
     *  Requires `Billing_CanViewInventory`, the same permission that reveals
     *  remaining report limits — so an organization can audit its own coins, and an
     *  admin can audit anyone's.
     *
     *  Note the CURRENT balance and the per-batch remaining/total/expiry do NOT need
     *  this call: they arrive on `AccountInfoStream` as `DiagnocoinWallet` and
     *  `DiagnocoinBatch`, which is what a balance widget should render. Use this when
     *  the question is "where did these coins go".
     *
     * @generated from rpc com.diagnocat.billing_new.Billing.ListDiagnocoinLedger
     */
    listDiagnocoinLedger: {
      name: "ListDiagnocoinLedger",
      I: ListDiagnocoinLedgerReq,
      O: ListDiagnocoinLedgerResp,
      kind: MethodKind.Unary,
    },
    /**
     *  Only for QA
     *
     * @generated from rpc com.diagnocat.billing_new.Billing.Test_ExpireSubscriptionAfter
     */
    test_ExpireSubscriptionAfter: {
      name: "Test_ExpireSubscriptionAfter",
      I: Test_ExpireSubscriptionAfterReq,
      O: Test_ExpireSubscriptionAfterResp,
      kind: MethodKind.Unary,
    },
  }
} as const;

